import { defineMessages } from 'react-intl';

export default defineMessages({
    previousBtn: {
        id: 'premiumreport.wc.page.details.Previous',
        defaultMessage: 'Previous'
    },
    nextBtn: {
        id: 'premiumreport.wc.page.details.Next',
        defaultMessage: 'Next'
    },
    amountsMustBeFilled: {
        id: 'premiumreport.wc.page.details.All audited amounts must be filled in to calculate premiums.',
        defaultMessage: 'All audited amounts must be filled in to calculate premiums.'
    }
});
